<div class="container-fluid" id="pres">
    <div class="row py-lg-5">
        <div class="col-sm-8 offset-sm-2">
            <mdb-card>
                <!-- Body -->
                <mdb-card-body>
                    <div class="row">
                        <div class="col-sm-6">
                            <h5>A propos de moi :</h5>
                            <p>
                                Bonjour, je m'appelle <b>Hugo Coleau</b>,diplômé Bac+4 en développement, je suis à la recherche d'un CDI.
                               
                                En tant que développeur junior, j'ai acquis
                                deux ans d'expérience en alternance au sein
                                d'une entreprise spécialisée dans l'infogérance
                                et le développement logiciel. Je suis
                                maintenant à la recherche de nouvelles
                                opportunités professionnelles dans ce
                                domaine et souhaite contribuer à des projets
                                passionnants qui me permettront de continuer
                                à développer mes compétences.
                                

                            </p>
                        </div>
                        <div class="col-sm-6">
                            <h5>Informations de base :</h5>
                            <ul>
                                <li class="text-pres row">
                                    <mat-icon class="col-3">cake</mat-icon> <span class="col-6">12/05/2000</span>
                                </li>
                                <li class="text-pres row">
                                    <mat-icon class="col-3">mail</mat-icon> <span class="col-6">coleau.hugo@gmail.com</span>
                                </li>
                                <li class="text-pres row">
                                    <mat-icon class="col-3">phone</mat-icon> <span class="col-6">06 66 07 34 74</span>
                                </li>
                                <li class="text-pres row">
                                    <mat-icon class="col-3">home</mat-icon> <span class="col-6"> 24 bis rue de villers 59198 Haspres </span>
                                </li>
                                <li class="text-pres row">
                                    <mat-icon class="col-3">flag</mat-icon> <span class="col-6"> Français, Anglais, Espagnol, Portugais </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </mdb-card-body>
            </mdb-card>
        </div>
    </div>
</div>